import React from 'react';

const FormTextArea = ({ name = '', value = '', placeholder, onValueChange, element = undefined }) => {
    return (
        <div className="flex-v mt-16">
            <div>
                <h4>{name} :</h4>
            </div>
            <div className="flex-h flex-between">
                <textarea className="textarea is-small" value={value} placeholder={placeholder} onChange={e => onValueChange(e.target.value, element)} />
            </div>
        </div>
    );
}

export default FormTextArea;